import { Component, AfterContentInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';

import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DossierService } from '../dossier.service';

import {
  AwardDTO,
  ProcurementProjectDTO,
  ProcurementProjectLotDTO,
  CompanyDTO,
  AwardLotDTO
} from '../../api/plyca-dtos-v2';
import { FormConfig } from '../../components/forms/form.objects';
import { Observable, of } from 'rxjs';
import {
  getSimpleIdentifierFromString,
  WorkDTO,
  TenderV2DTO,
  TenderLotV2DTO,
  TenderAdmissionStatusCodeDTO,
  TenderStateDTOV2,
  TaskDTO
} from '../../api/plyca-dtos';
import { Configuration } from '../../conf/app.constants';
import { FieldConfig } from '../../api/contract-notice-dto';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { finalize, take } from 'rxjs/operators';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { TranslateService } from '@ngx-translate/core';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { SelectItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

@Component({
  selector: 'awardCreation',
  templateUrl: 'awardCreation.template.html',
  providers: [DialogService, UIService]
})
// tslint:disable-next-line:class-name
export class awardCreationComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;

  _awardId: string;
  award: AwardDTO;
  project: ProcurementProjectDTO;
  pendingLots: Array<ProcurementProjectLotDTO>;
  tendersList: Array<TenderV2DTO>;
  awardsList: Array<AwardDTO>;
  filteredAwardsList: Array<AwardDTO>;
  company: Array<AwardDTO>;
  filteredTendersList: Array<TenderV2DTO>;
  tenderLots: Array<ProcurementProjectLotDTO> = [];
  taskWork: WorkDTO;
  task: TaskDTO;

  selectedLots: Array<ProcurementProjectLotDTO> = [];
  lotsModel: SelectItem[];

  // referencia al formulario de edicion de datos
  formConfig: FormConfig;

  windowHash: string;
  tagsParent: string[];

  TenderAdmissionStatusCode = TenderAdmissionStatusCodeDTO;

  @ViewChild('element') elementForm: ElementRef;
  showMessageOpened: boolean;

  constructor(
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public dossierService: DossierService,
    public configuration: Configuration,
    public helpService: HelpService,
    private ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private focusTrap: FocusTrapFactory,
    private elem: ElementRef,
    private waitService: WaitLoadingService,
    private headerActionsService: HeaderActionsService,
    private plycaErrorHandler: PlycaErrorHandler,
    public translate: TranslateService
  ) {
    super();
    let context = dialogConfig['context'];
    let data = dialogConfig['data'];

    this.subscribe(this.helpService.showContextHelpObservable(HelpType.CREAR_ADJUDICACION));

    if (context) {
      console.log('AWARDVIEW, CONTEXT:', context);
      this.tagsParent = context['tags'];
      this._awardId = context['awardId'];
      this.project = context['project'];
      this.pendingLots = context['pendingLots'];
      this.taskWork = context['taskWork'];
      this.task = data;
      this.pendingLots = this.pendingLots.filter(lote => !lote.rejectedLot && this.isLotavailable(lote));


      this.tendersList = context['tendersList'];
      this.awardsList = context['awardsList'];
      if (context['selectedLots']) {
        this.selectedLots = context['selectedLots'];
        this.selectedLots = this.selectedLots.filter(lote => !lote.rejectedLot && this.isLotavailable(lote));
        this.filterTenders();
      }
      this.company = context['company'];
      if (this.pendingLots !== undefined) {
        this.lotsModel = this.pendingLots.map(lot => {
          return { label: lot.description, value: lot };
        });
      }
      if (context['lot']) {
        // seleccionando lote
        console.log('lote recibo, seleccionandolo', context['lot']);
        this.selectedLots.push(context['lot']);
        this.filterTenders();
      } else {
        if (context['lot0'] !== undefined) {
          console.log('Expediente sin lotes');
          if (this.selectedLots === undefined) {
            this.selectedLots.push(context['lot0']);
          }
          this.filteredTendersList = this.tendersList;
        }
      }
      // Ordenamos por puntuacion
      this.sortTendersByLotClasification(this.selectedLots[0].lotId);

    } else {
      console.log('No se ha recibido context al abrir awardView', dialogConfig);
    }

  }

  sortTendersByLotClasification(lotId: number, order?: number) {
    // Ordenamos por puntuacion para el lote del parámetro
    if (order === undefined) {
      order = 1;
    }
    this.filteredTendersList.sort((tender1: TenderV2DTO, tender2: TenderV2DTO) => {
      let tenderLotsFiltered1 = tender1.tenderLots.find(tenderLot => tenderLot.procurementProjectLot.lotId === lotId);
      // this.selectedLots.find(lot => lot.lotId === tenderLot.procurementProjectLot.lotId));
      let tenderLotsFiltered2 = tender2.tenderLots.find(tenderLot => tenderLot.procurementProjectLot.lotId === lotId);
      // this.selectedLots.find(lot => lot.lotId === tenderLot.procurementProjectLot.lotId));
      if (!tenderLotsFiltered1) {
        return order * 99;
      } else if (!tenderLotsFiltered2) {
        return order * -99;
      } else {
        return order * (this.getClasification(tender1, tenderLotsFiltered1) - this.getClasification(tender2, tenderLotsFiltered2));
      }
    })
  }

  ngAfterContentInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-lg fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.cancel();
    });

    this.subscribe(this.loadAward(this._awardId), (_award: AwardDTO) => {
      console.log('Recibida ', _award);
      this.award = _award;
      // cargamos el form
      this.formConfig = new FormConfig(undefined,
        'awardInterfaceSettings.json',
        this.award
      );


      this.loaded = true;

      if (this.elementForm) {
        this.elementForm.nativeElement.focus();
      }
      this.waitService.cancelWaiting();




    });


  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent));
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  close() {
    this.ref.close(this.award);
  }

  loadAward(identifier: string): Observable<any> {
    if (identifier) {
      return this.plycaService.getDossierAward(identifier);
    } else {
      return of(new AwardDTO());
    }
  }

  changeLots(event) {
    // event.value: Current selected values
    // event.itemValue: Toggled item value
    let itemValue = event.itemValue;
    console.log(itemValue);
    this.filterTenders();
  }

  filterTenders() {
    this.filteredTendersList = [];


    let _filteredTendersList = [];
    let _tenderLots: Array<ProcurementProjectLotDTO> = [];
    // Quitamos los lotes de ofertas adjudicadas
    this.tendersList.forEach(tender => {
      if (tender.tenderLots == undefined) {
        tender.tenderLots = [];
      }
      tender.tenderLots = tender.tenderLots.filter(tenderLot =>
        this.awardsList.filter(award =>
          award.company !== undefined
          && award.company.identifier === tender.tendererParty.company.identifier
          && award.awardsLots.filter(awardLot => awardLot.projectLot.lotId === tenderLot.procurementProjectLot.lotId).length > 0
        ).length === 0
      );
    });

    if (this.selectedLots) {
      // filtramos las ofertas en funcion de los lotes seleccionados
      _filteredTendersList = this.tendersList.filter(tender => {
        let tenderLotsFiltered = tender.tenderLots.filter(tenderLot =>
          this.selectedLots.find(
            lot =>
              lot.lotId === tenderLot.procurementProjectLot.lotId
          ) && !this.isLotAwarded(tenderLot, tender.orderNumber)
          && tenderLot.tenderEvaluation.admissionStatus !== undefined
          && tenderLot.tenderEvaluation.admissionStatus.statusCode === TenderAdmissionStatusCodeDTO.ACEPTED
        );

        // si la oferta contiene alguno de los lotes
        // hay que utilizar esta oferta incluimos sus lotes en la lista global para las columnas de la tabla
        if (tenderLotsFiltered.length > 0) {
          tenderLotsFiltered.forEach(tenderLot => {

            // Comprobar si el lote esta en la lista de lotes;
            let _loteBuscado = _tenderLots.find(
              _tLot =>
                _tLot.lotId === tenderLot.procurementProjectLot.lotId
            );

            // Si el lote no esta en la lista se incorpora
            if (!_loteBuscado) {
              let _lot = this.getProjectLotById(tenderLot);
              if (_lot) {
                _tenderLots.push(_lot);
              }
            }
          });
        }


        return tender.document.currentState.identifier !== TenderStateDTOV2.REJECTED && tenderLotsFiltered && tenderLotsFiltered.length > 0;
      });

      // ordenar la lista resultante de lotes
      _tenderLots.sort((l1, l2) => {
        if (l1.lotNumber < l2.lotNumber) {
          return -1;
        } else {
          return 1;
        }
      });
    }
    this.tenderLots = _tenderLots;
    this.filteredTendersList = _filteredTendersList;
  }

  getTenderLotById(tender: TenderV2DTO, lotNumber: any) {
    let _lot = tender.tenderLots.find(
      tenderLot =>
        lotNumber === tenderLot.procurementProjectLot.lotNumber
    );
    return _lot;
  }

  getProjectLotById(tLot: TenderLotV2DTO): ProcurementProjectLotDTO {
    if (this.project.breakdownLot.apportioned) {
      return this.project.breakdownLot.lots.find(
        lot =>
          lot.lotId === tLot.procurementProjectLot.lotId
      );
    } else {
      return this.project.breakdownLot.totalLots;
    }
  }

  createAwardByCompany(company: CompanyDTO) {
    let award: AwardDTO = new AwardDTO();
    award.company = company;
    award.task = this.task;
    if (company === undefined) {
      let strMessage = 'Debe seleccionar la empresa adjudicataria.';
      if (!this.showMessageOpened) {
        this.showMessageOpened = true;
        this.uiService
          .showMessage(strMessage).onClose.pipe(take(1)).subscribe(
            () => this.showMessageOpened = false
          );
      }
    } else {
      // si hay desglose y lotes seleccionados
      if (this.project.breakdownLot.apportioned && this.selectedLots.length > 0) {
        award.awardsLots = [];
        this.selectedLots.forEach(lot => {
          award.awardsLots.push(this.lot2TenderLot(lot, new TenderV2DTO()));
        });
      }

      // Arrastramos el dato PyME de la empresa
      if (company
        && company.customFields
        && company.customFields.EMP_ES_PYME_STD
      ) {
        if (company.customFields.EMP_ES_PYME_STD.identifier === '1<>nulo') {
          award.pyme = true;
        } else if (company.customFields.EMP_ES_PYME_STD.identifier === '2<>nulo') {
          award.pyme = false;
        }
      }

      console.log('CREANDO ADJUDICACION POR EMPRESA', company, award);
      this.createAward(award);
    }
  }

  private lot2TenderLot(lot: ProcurementProjectLotDTO, tender: TenderV2DTO) {
    let awardLot: AwardLotDTO = new AwardLotDTO();
    awardLot.projectLot = lot;

    return awardLot;
  }

  createAwardByTender(tender: TenderV2DTO, lot?: TenderLotV2DTO) {
    let award: AwardDTO = new AwardDTO();
    let continuar = true;
    award.tender = tender;
    award.company = tender.tendererParty.company;

    award.task = this.task;

    // Arrastramos el dato PyME de la oferta
    if (tender
      && tender.tendererParty
      && tender.tendererParty.isSmallOrMediumSizedEnterprise
    ) {
      award.pyme = tender.tendererParty.isSmallOrMediumSizedEnterprise;
    }

    let selectedLotsFiltered = Array<ProcurementProjectLotDTO>();
    // si hay desglose y lotes seleccionados
    award.awardsLots = [];
    if (this.project.breakdownLot.apportioned) {
      let strMessage = 'Se va a adjudicar a la oferta: '
        + (award.company.name !== undefined ? award.company.name : award.company.taxIdentifier);
      if (lot) {
        strMessage = strMessage + ' para el lote: ' + this.getProjectLotById(lot).lotNumber;
      }
      continuar = false;
      this.uiService.showConfirmMessage({
        message: this.translate.instant(strMessage),
        header: this.translate.instant('General.confirmtext'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          continuar = true;
          if (lot) {
            award.awardsLots.push(this.lot2TenderLot(this.getProjectLotById(lot), award.tender));
          } else {
            selectedLotsFiltered = this.selectedLots.filter(selectedLot => tender.tenderLots.find(tenderLot => selectedLot.lotId ===
              tenderLot.procurementProjectLot.lotId
              && tenderLot.tenderEvaluation.admissionStatus.statusCode === TenderAdmissionStatusCodeDTO.ACEPTED
            ));
            if (selectedLotsFiltered.length > 0) {
              selectedLotsFiltered.forEach(filteredLot => {
                award.awardsLots.push(this.lot2TenderLot(filteredLot, award.tender));
              });
            } else {
              award.awardsLots.push()
            }
          }
          this.createAward(award);
        },
        reject: () => {
          continuar = false;
        }
      });

    } else {
      if (lot) {
        award.awardsLots.push(this.lot2TenderLot(this.getProjectLotById(lot), award.tender));
      }
    }
    console.log('CREANDO ADJUDICACION POR OFERTA', tender, lot, award);
    if (continuar) {
      this.createAward(award);
    }
  }



  createAward(award: AwardDTO) {
    award['dossierID'] = this.project.identifier;
    award['description'] = this.award.awardDescription;
    this.waitService.startWaiting();
    this.subscribe(this.plycaService.insert<AwardDTO>(this.configuration.AWARD_SERVICE_URL, award).pipe(

      finalize(() => {

        this.waitService.cancelWaiting();
      })
    ),
      response => {
        console.log('INSERT AWARD OK', response);
        this.ref.close(response);
      },
      error => {
        console.log('INSERT AWARD ERROR', error);
        this.plycaErrorHandler.showServerError(error).onClose.pipe(take(1)).subscribe(() => this.ref.close());
        // if (error.errors) {
        //   let errores: Array<ValidationExecutionDTO> = error.errors;
        //   let strMessage = '';
        //   errores.forEach((err: ValidationExecutionDTO) => {
        //     strMessage += err.message;
        //   });
        //   this.uiService
        //     .showMessage(strMessage).onClose.subscribe(() => this.ref.close(strMessage));
        // }
      }
    );
  }

  cancel() {
    this.ref.close();
  }

  public getFieldConfig(name: string): FieldConfig {
    let config = new FieldConfig();
    config.type = 'SEARCH';
    config.tooltipText = 'Seleccionar empresa adjudicataria';
    config.jsonField = 'company';
    config.description = 'Empresa adjudicataria:';
    config.autoSearch = false;
    config.idBuscador = 'com.nexusit.plyca.admin.interfaz.BuscadorEmpresasRIL';
    return config;
  }

  redondeaDosDecimal(num) {
    return Math.round(num * 100) / 100;
  }

  getClasification(selectedTender: TenderV2DTO, lot: TenderLotV2DTO) {
    if (lot && lot.tenderEvaluation) {
      let tenderPunctuation = lot.tenderEvaluation.subjectiveAwardCriteriaTotalScore +
        lot.tenderEvaluation.objectiveAwardCriteriaTotalScore;
      let clasification = 1;
      (this.filteredTendersList.length > 0 ? this.filteredTendersList : this.tendersList).forEach(tender => {
        if (tender.identifier !== selectedTender.identifier && tender.document.currentState.identifier !== '13') {
          tender.tenderLots.forEach(tenderLot => {
            if (tenderLot.tenderEvaluation.admissionStatus === undefined ||
              tenderLot.tenderEvaluation.admissionStatus.statusCode !== TenderAdmissionStatusCodeDTO.EXCLUDED) {
              if (tenderLot.procurementProjectLot.lotId === lot.procurementProjectLot.lotId) {
                let tenderLotPunctuation = tenderLot.tenderEvaluation.subjectiveAwardCriteriaTotalScore +
                  tenderLot.tenderEvaluation.objectiveAwardCriteriaTotalScore;
                if (tenderLotPunctuation > tenderPunctuation) {
                  clasification++;
                };
              }
            }
          });

        };
      });
      return clasification;
    }
  }

  isLotavailable(_lot: ProcurementProjectLotDTO) {
    if (this.taskWork.context.configurations.lotsAvailables) {
      let lotsAvailableList = this.taskWork.context.configurations.lotsAvailables.value;
      if (lotsAvailableList !== undefined && lotsAvailableList.length > 0) {
        let resultado = false;
        lotsAvailableList.forEach((lot: ProcurementProjectLotDTO) => {
          if (_lot && (lot.lotId === _lot.lotId)) {
            resultado = true;
          }
        });
        return resultado;
      }
    }
    return true;
  }

  isLotAwarded(_lot: TenderLotV2DTO, orderNumber: number) {
    let resultado = false;
    this.awardsList.forEach(award => {
      if (award.tender !== undefined && award.tender.orderNumber === orderNumber) {
        award.awardsLots.forEach(awardLot => {
          if (getSimpleIdentifierFromString(_lot.identifier) === '' + awardLot.projectLot.lotId) {
            resultado = true;
          }
        });
      }
    });
    return resultado;
  }

  isAwardMultiplesLots(): boolean {
    if (this.taskWork && this.taskWork.context && this.taskWork.context.configurations
      && this.taskWork.context.configurations.awardMultiplesLots
      && this.taskWork.context.configurations.awardMultiplesLots.value) {
      return true;
    } else {
      return false;
    }
  }

  sortLot(event) {
    console.log('Ordenando Ofertas por lote ' + event.field);
    this.sortTendersByLotClasification(Number(event.field), event.order);
  }

  isAwardCompanyAvailable() {
    let resultado = true;
    if (this.taskWork.context.configurations.awardCompany) {
      resultado = this.taskWork.context.configurations.awardCompany.value;
    }
    return resultado;
  }

}
